import {
    Row,
    Col,
    Button,
    Badge
} from "react-bootstrap"

import { ChevronRight } from "lucide-react"

import Image from "../CustomImage"
import Stars from "../Stars"
import ItemFocus from './ItemFocus'


const CompanyGroupItem = (props) => {
    const { item, linkage } = props;
    const reviews = parseFloat(item.score?.find(x => x.code === 'MREV')?.points || 0);
    const stars = Math.round(reviews) / 2;

    const clients_experience = item.score?.find(x => x.code === 'MPORT')?.points ?? 0;
    const brand_recognition = item.score?.find(x => x.code === 'MBM')?.points ?? 0;
    const track_record = item.score?.find(x => x.code === 'MAWRD')?.points ?? 0;
    const geo_strategy = item.score?.find(x => x.code === 'MNLOC')?.points ?? 0;

    const hasLocalReviews = item.score?.some(x => x && x.is_local_reviews === true);

    return (
        <Row>
            <Col lg="4" className="align-self-start mb-4 mb-lg-0">
                <div className="d-flex mb-2 example-parent">
                    <div className="d-flex align-items-center mb-3 me-auto">
                        <h3 className="h5 mb-0">{item.title}</h3>
                        <div className="avatar avatar-sm avatar-border-white ms-3 overflow-hidden">
                            <Image
                                src={item.logo_url}
                                alt={`${item.title} ${linkage?.label || ''} company logo`}
                                width={36}
                                height={36}
                                className="d-block"
                            />
                        </div>
                    </div>
                </div>
                <div className="mb-3 d-flex flex-column align-items-start gap-2">
                    {hasLocalReviews && (
                        <div>
                            <span className="text-xs">
                                <Stars color={'text-primary'} stars={stars} />
                            </span>
                        </div>
                    )}
                    <Button
                        href={item.vendor_url}
                        variant="link"
                        className="ps-0 fw-bold pb-0 pt-0 d-inline-flex align-items-center"
                    >
                        VIEW PROFILE <ChevronRight className="ms-2" size={12} />
                    </Button>
                    <Button
                        href={item.website_url}
                        rel="nofollow noopener noreferrer"
                        variant="secondary"
                        target="_blank"
                    >Visit website
                    </Button>
                </div>
            </Col>
            <Col lg="8">
                <Row>
                    <Col xs="6" md="4" lg="3" className="py-3 mb-3 mb-lg-0">
                        <div className="label-heading">Company size</div>
                        <p className="text-sm fw-bold">
                            {item.company_size}
                        </p>
                        <div className="label-heading">Founded</div>
                        <p className="text-sm fw-bold mb-0">
                            {item.founded}
                        </p>
                    </Col>
                    <Col xs="6" md="4" lg="3" className="py-3 mb-3 mb-lg-0">
                        <div className="label-heading">Hourly rate</div>
                        <p className="text-sm fw-bold">
                            {item.hourly_rate}
                        </p>
                        <div className="label-heading">Minimal project</div>
                        <p className="text-sm fw-bold mb-0">
                            {item.minimal_project}
                        </p>
                    </Col>
                    <Col xs="6" md="4" lg="3" className="py-3 mb-3 mb-lg-0">
                        <div className="label-heading">Headquarters</div>
                        <p className="text-sm fw-bold">
                            {item.location}
                        </p>
                        <div className="label-heading">Ready to start</div>
                        <p className="text-sm fw-bold mb-0">
                            {item.ready_to_start}
                        </p>
                    </Col>
                    <Col xs="6" md="4" lg="3" className="py-3 mb-3 mb-lg-0 text-lg-end rating-sub-score-box">
                        <div className="label-heading">Overall score</div>
                        <Badge bg={'light'} className="border rounded-0 text-black-50 bg-white">
                            <Button
                                href={'#'}
                                className="text-lg border-0 score-btn"
                                variant="secondary"
                            >{item.points}
                            </Button>
                        </Badge>
                    </Col>
                </Row>
                <Row>
                    <Col md="12" lg="12" className="py-3 mb-3 mb-lg-0">
                        <ItemFocus item={item} linkage={linkage} />
                        
                        <div className="d-flex flex-wrap mt-3">
                            {[
                                { label: "Clients & experience", value: clients_experience },
                                { label: "Reviews", value: reviews },
                                { label: "Brand recognition", value: brand_recognition },
                                { label: "Track record", value: track_record },
                                { label: "Geo strategy", value: geo_strategy }
                            ].map((subScore, idx) => (
                                <div key={idx} className="text-start flex-fill rating-sub-score-item">
                                    <div className="label-heading">{subScore.label}</div>
                                    <p className="text-sm fw-bold mb-0">{subScore.value}</p>
                                </div>
                            ))}
                        </div>
                    </Col>
                </Row>
            </Col>
        </Row>
    )
}

export default CompanyGroupItem